

























import { Component, Prop, Vue } from 'vue-property-decorator';
import { mapState, mapGetters } from 'vuex';

@Component({
    computed: {
        ...mapState(['coalitions', 'parliament']),
        ...mapGetters(['partyByID', 'coalitionSeats']),
    },
})
export default class Coalitions extends Vue {}
